/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MotivoTariffaCittadino } from './motivo-tariffa-cittadino';
import { FonteIseeTariffa } from './fonte-isee-tariffa';
import { PeriodoEsenzioneTariffaDTO } from './periodo-esenzione-tariffa-dto';
import { OrdinamentoScolastico } from './ordinamento-scolastico';


export interface MotivoTariffaDTO { 
    codice?: MotivoTariffaCittadino;
    esente_ora?: boolean;
    periodi?: Array<PeriodoEsenzioneTariffaDTO>;
    isee_valore?: number;
    isee_anno?: number;
    isee_fonte?: FonteIseeTariffa;
    isee_oltre?: number;
    isee_da?: number;
    isee_fino_a?: number;
    residente?: boolean;
    residenza_indeterminata?: boolean;
    comune?: string;
    ordinamento?: OrdinamentoScolastico;
    posizione?: number;
    totale?: number;
    esenti_esclusi?: boolean;
    costo_pasto_prima?: number;
    costo_pasto_dopo?: number;
    contributo?: number;
    numero_pasti?: number;
    costo_pasto?: number;
}



